import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { IGlpStudySpecifics, IGlpStudySpecificsDetail } from 'src/app/models/glp-study-specifics.model';
import { ActionButtonService } from '../../shared/action-button/action-button.service';
import { ActiveIngredientService } from '../../shared/active-ingredient-selector/active-ingredient.service';
import { GridService } from '../../shared/grid-components/grid/grid.service';
import { InnerGridService } from '../../shared/grid-components/inner-grid/inner-grid.service';
import { GlpStudySpecificsToxicologyService } from './glp-study-specifics-toxicology.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import { IResponse } from 'src/app/models/response.model';
import { IActiveIngredient } from 'src/app/models/active-ingredient.model';
import { UserService } from 'src/app/providers/user.service';




@Component({
  selector: 'app-glp-study-specifics-toxicology',
  templateUrl: './glp-study-specifics-toxicology.component.html',
  styleUrls: ['./glp-study-specifics-toxicology.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class GlpStudySpecificsToxicologyComponent implements OnInit {
  
  destroy$: Subject<boolean> = new Subject<boolean>();
  public currentActiveIngredient: IActiveIngredient;

  public admeColumnDefs: (ColDef | ColGroupDef)[] = [];
  public acuteColumnDefs: (ColDef | ColGroupDef)[] = [];
  public shortTermColumnDefs: (ColDef | ColGroupDef)[] = [];
  public genotoxicologyColumnDefs: (ColDef | ColGroupDef)[] = [];
  public reproductivityColumnDefs: (ColDef | ColGroupDef)[] = [];
  public toxicityMetabolitesColumnDefs : (ColDef | ColGroupDef)[] = [];

  public rowData: IGlpStudySpecifics[];
  public admeDataRow: IGlpStudySpecifics[];
  public acuteDataRow: IGlpStudySpecifics[];
  public reproductivityDataRow: IGlpStudySpecifics[];
  public shortTermDataRow: IGlpStudySpecifics[];
  public genotoxicologyDataRow: IGlpStudySpecifics[];
  public toxicityMetabolitesDataRow: IGlpStudySpecifics[];
  public selectedRow: IGlpStudySpecifics | null;
  public selectedNode;
  public rowSelection = 'single';
  public studySection: any;
  private actionButtonSubscription: any;
  public rowHeight: number = 50;
  public IsToxicology: boolean = true;
  public ToxicologyActionButtons: MenuItem[];

  public innerGridRowIndex = 0;


  constructor(private glpStudySpecificsServiceToxicology: GlpStudySpecificsToxicologyService,
    private messageService: MessageService,
    public AiService: ActiveIngredientService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private actionButtonService: ActionButtonService,
    private gridService: GridService,
    private innerGridService: InnerGridService,
    private userService: UserService,
  ) { }
  ngOnInit(): void {
    this.ToxicologyActionButtons = [
      {label: 'Adme',icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("Adme",this.admeDataRow)}},
      {label: 'Acute', icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("Acute",this.acuteDataRow)}},
      {label: 'Short Term', icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("ShortTerm",this.shortTermDataRow)}},
      {label: 'Genotoxicology', icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("Genotoxicology",this.genotoxicologyDataRow)}},
      {label: 'Reproductivity', icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("Reproductivity",this.reproductivityDataRow)}},
      {label: 'Toxicity on Metabolites', icon: 'pi pi-plus', command: () => {this.onAddGLPStudySpecifics("ToxicityMetabolites",this.toxicityMetabolitesDataRow)}},

    ];

    this.actionButtonService.Editable = false;
    this.actionButtonService.UseEditMode = true;
    this.studySection = this.route.snapshot.url[0].path.toString();
    this.loadReadOnlyColumnDefs();

    if (this.AiService.SelectedActiveIngredient) {
      this.getGLPStudySpecifics(this.AiService.SelectedActiveIngredient.material_id, this.studySection);
    }
    this.AiService.selectedActiveIngredient$.pipe(takeUntil(this.destroy$)).subscribe(async selectedActiveIngredient => {
      if (selectedActiveIngredient && selectedActiveIngredient != this.currentActiveIngredient){
        this.currentActiveIngredient = selectedActiveIngredient;
        await this.getGLPStudySpecifics(selectedActiveIngredient.material_id, this.studySection);
      }
    });
    this.selectedRow = null;
    this.actionButtonService.editable$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (value) this.reload(false);
      if (!value) this.reload(true);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.innerGridRowIndex = 0;
  }

  //  Description: On Selection Changed Event
  //  Author: George Ulecia
  //  Creation date: 23/Feb/2023   
  //  <history>
  //     <update> H00 - RD-78
  //              Description: Creation.
  //     </update>
  // </history>
  onSelectionChanged(event) {
    this.selectedRow = event as IGlpStudySpecifics;
  }

  //  Description: Load Read Only Columns Definition Method
  //  Author: George Ulecia
  //  Date: 04/Jan/2023
  //  <history>
  //     <update> H00 - RD-78
  //              Description: Creation.
  //     </update>
  // </history>
  loadReadOnlyColumnDefs() {
    const admeColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "Adme").toPromise();
    admeColsDef.then(ColDefs => {
      this.admeColumnDefs = ColDefs;
    });
    const acuteColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "Acute").toPromise();
    acuteColsDef.then(ColDefs => {
      this.acuteColumnDefs = ColDefs;
    });
    const genotoxicologyColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "Genotoxicology").toPromise();
    genotoxicologyColsDef.then(ColDefs => {
      this.genotoxicologyColumnDefs = ColDefs;
    });
    const shortTermColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "ShortTerm").toPromise();
    shortTermColsDef.then(ColDefs => {
      this.shortTermColumnDefs = ColDefs;
    });
    const reproductivityColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "Reproductivity").toPromise();
    reproductivityColsDef.then(ColDefs => {
      this.reproductivityColumnDefs = ColDefs;
    });
    const toxicityMetabolitesColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, false, "ToxicityMetabolites").toPromise();
    toxicityMetabolitesColsDef.then(ColDefs => {
      this.toxicityMetabolitesColumnDefs = ColDefs;
    });
  }

  //  Description: Load Editable Columns Definition Method
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  //              Description: Creation.
  //     </update>
  // </history>
  loadEditableColumnDefs() {
    const admeColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "Adme").toPromise();
    admeColsDef.then(ColDefs => {
      this.admeColumnDefs = ColDefs;
    });
    const acuteColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "Acute").toPromise();
    acuteColsDef.then(ColDefs => {
      this.acuteColumnDefs = ColDefs;
    });
    const genotoxicologyColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "Genotoxicology").toPromise();
    genotoxicologyColsDef.then(ColDefs => {
      this.genotoxicologyColumnDefs = ColDefs;
    });
    const shortTermColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "ShortTerm").toPromise();
    shortTermColsDef.then(ColDefs => {
      this.shortTermColumnDefs = ColDefs;
    });
    const reproductivityColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "Reproductivity").toPromise();
    reproductivityColsDef.then(ColDefs => {
      this.reproductivityColumnDefs = ColDefs;
    });
    const toxicityMetabolitesColsDef = this.glpStudySpecificsServiceToxicology.getGLPStudySpecificsColumnsDef(this.studySection, true, "ToxicityMetabolites").toPromise();
    toxicityMetabolitesColsDef.then(ColDefs => {
      this.toxicityMetabolitesColumnDefs = ColDefs;
    });
  }



  reload(readyOnlyMode: boolean) {
    if (this.AiService.SelectedActiveIngredient) {
      this.getGLPStudySpecifics(this.AiService.SelectedActiveIngredient?.material_id, this.studySection).then(() => {
        if (readyOnlyMode) this.loadReadOnlyColumnDefs();
        if (!readyOnlyMode) this.loadEditableColumnDefs();
      });
    }
  }

  /// <summary>
  ///     Description: Confirmation windonw
  ///     Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  ///         Description: Creation, not working as it will be worked on a separate story.
  ///     </update>
  /// </history>
  deleteConfirmation = (target: EventTarget, callback) => {
    this.confirmationService.confirm({
      target: target,
      message: 'Are you sure that you want to Delete?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        callback(true);
      },
      reject: () => {
        callback(false);
      }
    });
  }
  /// <summary>
  ///     Description: Cancel Confirmation windonw
  ///     Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  ///         Description: Creation, not working as it will be worked on a separate story.
  ///     </update>
  ///     <update> H01 - RD-120
  ///         Description: Changed dialog message.
  ///     </update>
  /// </history>
  cancelConfirmation = (target: EventTarget, callback) => {
    this.confirmationService.confirm({
      target: target,
      header: 'Are you sure?',
      message: 'Are you sure you want to cancel the changes?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        callback(true);
      },
      reject: () => {
        callback(false);
      }
    });
  }

  async getGLPStudySpecifics(materialId: number, section: string) {
    if (!materialId) return;
    await this.glpStudySpecificsServiceToxicology?.getGLPStudySpecificsDataByMaterialID(materialId, section)
      .pipe(take(1))
      .subscribe((result: IGlpStudySpecifics[]) => {
        this.rowData = result;
        this.admeDataRow = this.filterAndMapRowData(this.rowData, '5.1');
        this.acuteDataRow = this.filterAndMapRowData(this.rowData, '5.2');
        this.shortTermDataRow = this.filterAndMapRowData(this.rowData, '5.3');
        this.genotoxicologyDataRow = this.filterAndMapRowData(this.rowData, '5.4');
        this.reproductivityDataRow = this.filterAndMapRowData(this.rowData, '5.6');
        this.toxicityMetabolitesDataRow = this.filterAndMapRowData(this.rowData, '5.8');
      })
  }

  filterAndMapRowData(rowData: IGlpStudySpecifics[], dossierPoint: string) {
    return rowData.filter(row => row.dossier_point.includes(dossierPoint));
  }

  //  Description: On Add Inner Grid Event
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  ///         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  onAddInnerGrid(event) {
    
    const selectedNode = event.selectedNode;
    const data = event.parentNode.data;
    if (!data.children) data.children = [];
    let newChildren;

    if (selectedNode == undefined || selectedNode?.level == 0)
      newChildren = this.newChild();

    if (selectedNode?.level == 1)
      newChildren = this.newChild(selectedNode.allLeafChildren[0].data.biosystemLevel1DropdownFieldValuePk);

    if (selectedNode?.level == 2 && selectedNode?.group == false)
      newChildren = this.newChild(selectedNode.data.biosystemLevel1DropdownFieldValuePk, selectedNode.data.biosystemLevel2DropdownFieldValuePk);

    if (selectedNode?.level == 2 && selectedNode?.group == true)
      newChildren = this.newChild(selectedNode.allLeafChildren[0].data.biosystemLevel1DropdownFieldValuePk, selectedNode.allLeafChildren[0].data.biosystemLevel2DropdownFieldValuePk);

    if (selectedNode?.level == 3 && selectedNode?.group == false) {
      newChildren = this.newChild(selectedNode.data.biosystemLevel1DropdownFieldValuePk, selectedNode.data.biosystemLevel2DropdownFieldValuePk, selectedNode.data.formulation);
    }
    data.children.unshift(newChildren);
    data.haveChanges = true;

    this.innerGridService.addTransaction([newChildren]);

    if (selectedNode?.level > 0) {
      this.innerGridService.updateTransaction(this.selectedRow.children);
      selectedNode.parent?.setExpanded(true);
      selectedNode.parent?.parent?.setExpanded(true);
      selectedNode.allLeafChildren?.forEach(node => {
        node.setExpanded(true);
      })
    }
  }
  //  Description: On Delete Inner Grid Event
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  ///         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  onDeleteInnerGrid(event) {
    const selectedNode = event.selectedNode;
    const data = event.parentNode.data;
    let deleteRows = [];
    if (selectedNode.group) {
      event.selectedNode.allLeafChildren.map(x => {
        deleteRows.push(x.data);
      });
    }
    if (!selectedNode.group) deleteRows.push(selectedNode.data);
    data.children = data.children.filter(x => !deleteRows.includes(x));
    this.innerGridService.removeTransaction(deleteRows);
    data.haveChanges = true;
  }

  /// <summary>
  ///     Description: Add GLPSpecifics to gridview (Memory)
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  ///         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  /// </summary>

  onAddGLPStudySpecifics(area, dataRow) {
    let temp = [...dataRow];
    const newRow = this.newMainRow();
    if (!temp) temp = [];
    temp.unshift(newRow);
    if(area=="Acute") this.acuteDataRow = temp;
    else if(area=="Adme") this.admeDataRow = temp;
    else if(area=="Genotoxicology") this.genotoxicologyDataRow = temp;
    else if(area=="Reproductivity") this.reproductivityDataRow = temp;
    else if(area=="ShortTerm") this.shortTermDataRow = temp;
    else if(area=="ToxicityMetabolites") this.toxicityMetabolitesDataRow = temp;
  }

  /// <summary>
  //  Description: New Main Row Method
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  ///         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  /// </summary>
  newMainRow(): IGlpStudySpecifics {
    return {
      material_id_core: this.AiService.SelectedActiveIngredient?.material_id,
      study_number: "",
      study_section: "",
      study_year: null,
      study_title: "",
      dossier_point_dropdown_field_value_pk: 0,
      pk: -Math.abs(this.rowData.length + 1),
      glp_study_specifics_pk: 0,
      children: [],
      listGLPStudySpecificsMetabolismDTO: [],
      listGLPStudySpecificsResiduesDTO: [],
      toxicology_specific_data: [],
      study_status_dropdown_field_value_pk: 0,
      haveChanges: true,
      created_by :  this.userService.profile.displayName,
      created_date: new Date(),
      updated_by : this.userService.profile.displayName,
      updated_date: new Date(),
      is_external: false,
      readOnly: false,
    };
  }


  //  Description: New Level 0 Method
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  newChild(level1?: any, level2?: any, formulation?: string): IGlpStudySpecificsDetail {
    this.innerGridRowIndex++;
    return {
      pk: -Math.abs(this.innerGridRowIndex),
      biosystemLevel1DropdownFieldValuePk: level1 ? level1 : -Math.abs(this.innerGridRowIndex),
      biosystemLevel2DropdownFieldValuePk: level2 ? level2 : -Math.abs(this.innerGridRowIndex),
      analyteMaterialId: undefined,
      analyteMaterialName: undefined,
      haveChanges: true,

      metabolitesRelevanceList: [],
      method: undefined,
      doses: undefined,
      loael: undefined,
      noael: undefined,
      results: undefined,
      route: undefined,
      sex: undefined,
      species: undefined,
      strain: undefined,
      study_type: undefined,
      test: undefined,
      test_object: undefined,
      test_item: undefined,
    };
  }

  /// <summary>
  ///     Description: method to confirm delete command
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  ///     </update>
  /// </history>
  onDeleteGLPStudySpecifics(event) {
    this.deleteConfirmation(event.target, (confirmed) => {
      if (confirmed) {
        this.deleteGLPStudySpecifics(this.selectedRow);
      }
    });
  }


  /// <summary>
  //     Description: Delete method
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  ///     </update>
  /// </history>
  deleteGLPStudySpecifics(data: IGlpStudySpecifics) {
    if (data.pk < 0) {
        this.admeDataRow = this.admeDataRow.filter(x => x.pk != data.pk);
        this.acuteDataRow = this.acuteDataRow.filter(x => x.pk != data.pk);
        this.shortTermDataRow = this.shortTermDataRow.filter(x => x.pk != data.pk);
        this.genotoxicologyDataRow = this.genotoxicologyDataRow.filter(x => x.pk != data.pk);
        this.reproductivityDataRow = this.reproductivityDataRow.filter(x => x.pk != data.pk);
        this.toxicityMetabolitesDataRow = this.toxicityMetabolitesDataRow.filter(x => x.pk != data.pk);
      return;
    }

    this.glpStudySpecificsServiceToxicology.deleteGLPStudySpecificsDataByID(data.glp_study_specifics_pk)
      .pipe(take(1))
      .subscribe(response => {
      if (response.statusCode == 200) {
        this.endEditMode();
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Delete action completed' });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Canceled', detail: 'Delete action canceled' });
      }
    });
  }

  //  Description: On Cancel Button Event
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  //  <history>
  //     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  //     </update>
  // </history>
  onCancelClicked(event) {
    this.cancelConfirmation(event.target, (confirmed) => {
      if (confirmed) {
        this.endEditMode();
      }
    });
  }

  /// <summary>
  ///     Description: Button action
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  ///     </update>
  /// </history>
  onSaveClick(event) {
    this.rowData = [];
    this.rowData =  this.rowData.concat(this.admeDataRow, this.acuteDataRow, this.shortTermDataRow, this.genotoxicologyDataRow, this.reproductivityDataRow, this.toxicityMetabolitesDataRow);
    this.processDatarow(this.rowData)
  }

  // <summary>
  ///     Description: Process Data Rows to Save them.
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  ///     </update>
  /// </history>
  processDatarow(data: IGlpStudySpecifics[]) {
    
    var materialID = this.AiService.SelectedActiveIngredient?.material_id;
    if (!materialID) {
      this.showNoChangesMessage();
      return;
    }
    const [tempDataSave, baseData] = data.reduce(
      ([tempDataSave, baseData], element) =>
        element.haveChanges ? [[...tempDataSave, element], baseData] : [tempDataSave, [...baseData, element]],
      [[], []]
    );
    tempDataSave.forEach(element => {
      element.dossier_point_dropdown_field_value_pk = Number(element.dossier_point_dropdown_field_value_pk);
      element.study_status_dropdown_field_value_pk = Number(element.study_status_dropdown_field_value_pk);
      element.material_id_core = materialID;
      element.study_section = this.studySection;
      
      element.created_by = element.glp_study_specifics_pk == 0 || !element.created_by ? this.userService.profile.displayName : element.created_by;
      element.created_date = element.glp_study_specifics_pk == 0 || !element.created_date ? new Date() : element.created_date;
      element.updated_by = this.userService.profile.displayName;
      element.updated_date = new Date();
    });
    if(this.isStudyNumberAnnexPointAvailable(tempDataSave,baseData)) {
    if (tempDataSave.length > 0) {
      this.saveGLPStudySpecifics(tempDataSave);
    }

    if (tempDataSave.length == 0) {
      this.showNoChangesMessage();
    }
  }
  }
  
  isStudyNumberAnnexPointAvailable(tempDataSave: IGlpStudySpecifics[], baseData: IGlpStudySpecifics[]) {
    const duplicatesExist = tempDataSave.some(item => {
      return baseData.some(row => {
        return row.dossier_point_dropdown_field_value_pk == item.dossier_point_dropdown_field_value_pk && row.study_number == item.study_number ;
      });
    });
    if (duplicatesExist) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Data duplicity detected.' });
    }
    return !duplicatesExist;
  }

  showNoChangesMessage() {
    this.messageService.add({ severity: 'warn', summary: 'No Changes', detail: 'There are no changes to save.' });
  }

 // <summary>
  ///     Description: Call GLPStudySpecifics Service to Save edited data.
  //  Author: George Ulecia
  //  Date: 23/Feb/2023
  /// </summary>
  /// <history>
  ///     <update> H00 - RD-78
  //         Description: Creation, not working(disabled) as it will be worked on a separate story.
  ///     </update>
  /// </history>
  saveGLPStudySpecifics(data: IGlpStudySpecifics[]) {
    this.glpStudySpecificsServiceToxicology.saveGLPStudySpecificsData(data)
    .pipe(take(1))
    .subscribe((response: IResponse) => {
      if (response.statusCode == undefined && response.message.includes('Error')) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while saving changes' });
        return;
      }
      this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Changes Saved' });
      this.endEditMode();
    });
  }

  endEditMode() {
    if (this.actionButtonService.UseEditMode) this.actionButtonService.Editable = false;
    this.innerGridRowIndex = 0;
  }

}
